import { render, staticRenderFns } from "./PriceEvaluation.vue?vue&type=template&id=82b08cca&scoped=true"
import script from "./PriceEvaluation.vue?vue&type=script&lang=js"
export * from "./PriceEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b08cca",
  null
  
)

export default component.exports